import React from 'react';
import {connect} from 'react-redux';
import StatusDescription from './components/status-description';
import './index.css';


class UserStatusesPopupMessage extends React.Component {
	render(){
		return (
			<StatusDescription />
		)
	}
}

const mapStateToProps = (state) => {
	return {
		sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup,
	};
};

export default connect(mapStateToProps)(UserStatusesPopupMessage);
